import { createUser as k, generateUserKey as C, sendPerfMetrics as F, removeMessageFeedback as I, addMessageFeedback as S, getEvent as T, createEvent as R, deleteUser as w, updateUser as K, getUser as _, createFile as q, deleteMessage as N, getMessage as z, updateMessage as A, createMessage as J, listParticipants as j, getParticipant as D, removeParticipant as V, addParticipant as X, listConversationMessages as Y, listConversations as B, deleteConversation as G, getConversation as H, createConversation as O } from "./webchat-client3.js";
import { client as l } from "./webchat-client4.js";
import { EventSource as Q } from "./webchat-client5.js";
import { throwErrorInterceptor as b } from "./webchat-client6.js";
import { createEventEmitter as $ } from "./webchat-client7.js";
const n = (a) => a.data, M = 10, P = 3e3, W = "60000", m = {
  throwOnError: !0
}, re = async ({
  clientId: a,
  apiUrl: c,
  adminSecret: d,
  customHeaders: o,
  ...h
}) => {
  const t = `${c || l.getConfig().baseUrl}/${a}`;
  l.interceptors.response._fns.length === 0 && l.interceptors.response.use(b);
  const i = {
    ...m,
    baseUrl: t
  }, s = {
    ...d ? { "x-admin-secret": d } : {},
    ...o
  };
  return k({
    ...i,
    headers: Object.keys(s).length > 0 ? s : void 0,
    body: h
  }).then(n);
}, ae = ({
  conversationId: a,
  userToken: c,
  clientId: d,
  apiUrl: o,
  adminSecret: h
}) => {
  let t = 0, i = null;
  const s = $();
  let f = a;
  const e = () => {
    i && i.close();
    const g = `${`${o || l.getConfig().baseUrl}/${d}`}/initialize${f ? `?conversationId=${f}` : ""}`, v = {
      ...h ? { "x-admin-secret": h } : {},
      ...c ? { "x-user-key": c } : {}
    };
    i = L(g, v), i.addEventListener("open", () => s.emit("open")), i.addEventListener("error", (u) => {
      t < M ? (t++, setTimeout(() => e(), P)) : s.emit("error", u);
    }), i.addEventListener("message", (u) => {
      const p = x(u.data);
      p.type === "init" && (f = p.data.conversation.id ?? f), s.emit(p.type, p.data);
    });
  };
  return e(), s.on;
}, oe = async ({
  adminSecret: a,
  expiresAt: c,
  userId: d,
  apiUrl: o,
  clientId: h
}) => {
  const t = { "x-admin-secret": a }, i = `${o || l.getConfig().baseUrl}/${h}`, s = {
    ...m,
    baseUrl: i
  };
  return C({ ...s, headers: t, body: { id: d, expiresAt: c } }).then(n);
}, ie = async (a, c, d, o) => {
  const h = `${d || l.getConfig().baseUrl}/${a}`, t = {
    ...m,
    baseUrl: h
  };
  return F({ ...t, body: c, headers: o }).then(n);
}, ce = ({
  userKey: a,
  clientId: c,
  apiUrl: d,
  customHeaders: o,
  advancedOptions: h
}) => {
  const t = {
    "x-user-key": a,
    ...o
  }, i = `${d || l.getConfig().baseUrl}/${c}`, s = {
    ...m,
    baseUrl: i
  };
  return l.interceptors.response._fns.length === 0 && l.interceptors.response.use(b), {
    createConversation: () => O({ ...s, headers: t, body: {} }).then(n),
    getConversation: ({ conversationId: e }) => H({ ...s, headers: t, path: { id: e } }).then(n),
    deleteConversation: ({ conversationId: e }) => G({ ...s, headers: t, path: { id: e } }).then(n),
    listConversations: ({ nextToken: e }) => B({ ...s, headers: t, query: { nextToken: e } }).then(n),
    listConversationMessages: ({ conversationId: e, nextToken: r }) => Y({
      ...s,
      headers: t,
      path: { id: e },
      query: { nextToken: r }
    }).then(n),
    addParticipant: ({ conversationId: e, userId: r }) => X({ ...s, headers: t, path: { id: e }, body: { userId: r } }).then(n),
    removeParticipant: ({ conversationId: e, userId: r }) => V({ ...s, headers: t, path: { id: e, userId: r } }).then(n),
    getParticipant: ({ conversationId: e, userId: r }) => D({ ...s, headers: t, path: { id: e, userId: r } }).then(n),
    listParticipants: ({ conversationId: e, nextToken: r }) => j({ ...s, headers: t, path: { id: e }, query: { nextToken: r } }).then(n),
    createMessage: (e) => J({ ...s, headers: t, body: e }).then(n),
    updateMessage: ({ messageId: e, ...r }) => A({ ...s, headers: t, path: { id: e }, body: r }).then(n),
    getMessage: ({ messageId: e }) => z({ ...s, headers: t, path: { id: e } }).then(n),
    deleteMessage: ({ messageId: e }) => N({ ...s, headers: t, path: { id: e } }).then(n),
    createFile: (e) => q({ ...s, headers: t, body: e }).then(n),
    getUser: () => _({ ...s, headers: t }).then(n),
    updateUser: (e) => K({ ...s, headers: t, body: e }).then(n),
    deleteUser: () => w({ ...s, headers: t }).then(n),
    createEvent: (e) => R({ ...s, headers: t, body: e }).then(n),
    getEvent: ({ eventId: e }) => T({ ...s, headers: t, path: { id: e } }).then(n),
    addMessageFeedback: ({ messageId: e, ...r }) => S({ ...s, headers: t, path: { id: e }, body: r }).then(n),
    removeMessageFeedback: ({ messageId: e }) => I({ ...s, headers: t, path: { id: e } }).then(n),
    generateUserKey: ({ adminSecret: e, ...r }) => C({ ...s, headers: { "x-admin-secret": e }, body: r }).then(n),
    listenConversation: ({ conversationId: e }) => {
      let r = 0, g = null;
      const v = $(), u = () => {
        g && g.close();
        const p = `${i}/conversations/${e}/listen`, E = h == null ? void 0 : h.eventSource;
        g = E ? E({ url: p, headers: t }) : L(p, t), g.addEventListener("open", () => v.emit("open")), g.addEventListener("error", (U) => {
          r < M ? (r++, setTimeout(() => u(), P)) : v.emit("error", U);
        }), g.addEventListener("message", (U) => {
          const y = x(U.data);
          v.emit(y.type, y.data);
        });
      };
      return u(), v.on;
    }
  };
}, x = (a) => {
  try {
    return JSON.parse(a);
  } catch {
    return a;
  }
}, L = (a, c) => new Q(a, {
  fetch: (d, o) => fetch(d, {
    ...o,
    headers: {
      ...o == null ? void 0 : o.headers,
      ...c,
      timeout: W
    }
  })
});
export {
  ce as createClient,
  re as createUser,
  oe as generateUserKey,
  ae as initialize,
  ie as sendPerfMetrics
};
